import { render, staticRenderFns } from "./TransferOrderDialog.vue?vue&type=template&id=27a0f6de&scoped=true"
import script from "./TransferOrderDialog.vue?vue&type=script&lang=js"
export * from "./TransferOrderDialog.vue?vue&type=script&lang=js"
import style0 from "./TransferOrderDialog.vue?vue&type=style&index=0&id=27a0f6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a0f6de",
  null
  
)

export default component.exports